import { LoginForm } from '@/components/LoginPage/LoginForm'
import { Screen } from '@/ui/core/screen'
import { View, useWindowDimensions } from 'react-native'

import { AppHeader } from '@/components/AppHeader'
import { AppStoreLinks } from '@/components/LoginPage/AppStoreLinks'
import Logo, { LogoColorVariant } from '@/components/svgs/Logo'
import { HStack, VStack } from '@/ui/core/stack'
import { Image } from 'expo-image'
import Images from '#/assets/images/image-map'

const MobileLoginView = () => {
	return (
		<Screen preset="fixed" className="flex flex-1">
			<AppHeader
				className="bg-transparent absolute z-30"
				logoColor={LogoColorVariant.BRIGHT}
				showNavigation={false}
			/>
			<Image
				style={{
					height: 250,
					width: '100%',
				}}
				source={Images.ProfileHeadshot}
				contentFit="cover"
				contentPosition={'bottom'}
			/>
			<View className="flex-1 bg-palette_2 justify-between">
				<LoginForm />
				<View className="h-[15%] native:h-0">
					<AppStoreLinks />
				</View>
			</View>
		</Screen>
	)
}

const DesktopLoginView = () => {
	return (
		<Screen preset="fixed" className="flex flex-1">
			<View className="absolute z-30 pt-6 pl-12">
				<Logo color={LogoColorVariant.BRIGHT} />
			</View>
			<HStack fullHeight>
				<Image
					style={{
						width: '45%',
						height: '100%',
						zIndex: 10,
					}}
					source={Images.ProfileHeadshotLarge}
					contentFit="cover"
				/>
				<Image
					style={{
						width: 16,
					}}
					source={Images.VerticalDivider}
					contentFit="cover"
				/>
				<VStack className="gap-[20%] flex flex-1 w-full h-full justify-center items-center">
					<VStack className="lg:px-[25%] px-0 h-[70vh] items-center">
						<LoginForm />
						<AppStoreLinks />
					</VStack>
				</VStack>
			</HStack>
		</Screen>
	)
}

export default function LoginScreen() {
	const { width } = useWindowDimensions()

	const showMobileView = width < 800

	return showMobileView ? <MobileLoginView /> : <DesktopLoginView />
}
